import React from "react";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

// Components
import ContentCardHeader from "src/components/ContentCardHeader";
import CaseMediaTipsButton from "src/components/CaseMediaTips/CaseMediaTipsButton";
import AddMedia from "src/components/AddMedia";
import Text from "src/components/Text";

// Config
import styles from "../../config/styles";

const useStyles = makeStyles(theme => ({
  root: {
    border: styles.values.border
  },
  buttonWrapper: {
    display: "flex",
    flexDirection: "row",
    gap: theme.spacing(1)
  }
}));

const CaseMediaPanelLayout = ({ children }) => {
  const classes = useStyles();

  return (
    <Paper elevation={0} className={classes.root}>
      <ContentCardHeader>
        <Text text="mediaPage.title" type="heading2" />
        <div className={classes.buttonWrapper}>
          <CaseMediaTipsButton page="mediaPage" />
          <AddMedia />
        </div>
      </ContentCardHeader>
      {children}
    </Paper>
  );
};

CaseMediaPanelLayout.propTypes = {
  children: PropTypes.node.isRequired
};

export default CaseMediaPanelLayout;
